const WrenchIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
      <g clip-path='url(#clip0_75644_18072)'>
        <path
          d='M15.3418 2.51727L12.2765 5.5826C11.7558 6.10327 10.9118 6.10327 10.3912 5.5826C9.8705 5.06193 9.8705 4.21793 10.3912 3.69727L13.4478 0.639268L13.2532 0.540601C12.5452 0.181268 11.7865 -0.000732422 10.9992 -0.000732422C8.24183 -0.000732422 5.99917 2.24193 5.99917 4.99927C5.99917 5.6386 6.11783 6.2566 6.35317 6.84393L0.611832 12.5859C-0.166835 13.3659 -0.166835 14.6339 0.611832 15.4139C1.00183 15.8039 1.51383 15.9986 2.02583 15.9986C2.53783 15.9986 3.0505 15.8039 3.4405 15.4139L9.1945 9.65993C9.77117 9.88593 10.3765 9.99994 10.9998 9.99994C13.7572 9.99994 15.9998 7.75727 15.9998 4.99993C15.9998 4.1946 15.8112 3.4226 15.4392 2.70527L15.3418 2.51727Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id='clip0_75644_18072'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default WrenchIcon;
